import React from "react";
import {
  Box, Text, Button, Slider, SliderTrack, 
  SliderFilledTrack, SliderThumb, VStack, HStack, Badge,
  Tooltip, Flex, Icon
} from "@chakra-ui/react";
import { FaArrowsAlt, FaLock } from "react-icons/fa";

const SizeTab = ({
  safeHeightMultiplier,
  safeWidthMultiplier,
  handleWidgetHeightMultiplierChange,
  handleWidgetWidthMultiplierChange,
  resetWidgetSize,
  accentColor
}) => {
  return (
    <VStack spacing={6} align="stretch" position="relative">
      {/* Locked overlay */}
      <Flex
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="rgba(255, 255, 255, 0.8)"
        zIndex="2"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        borderRadius="md"
      >
        <Icon as={FaLock} boxSize={8} color={accentColor} mb={3} />
        <Text fontWeight="medium" textAlign="center" mb={1}>
          Size customization is locked
        </Text>
        <Text fontSize="sm" color="gray.600" textAlign="center">
          This options is currently disabled. If you need to adjust the size, please contact support.
        </Text>
      </Flex>
      
      {/* Original content (now dimmed behind overlay) */}
      <Box>
        <HStack justify="space-between" mb={2}>
          <Text fontSize="sm" fontWeight="medium">Widget Height</Text>
          <Badge colorScheme="green">{safeHeightMultiplier.toFixed(2)}×</Badge>
        </HStack>
        <Slider
          value={safeHeightMultiplier}
          min={0.5}
          max={1.75}
          step={0.05}
          onChange={handleWidgetHeightMultiplierChange}
          mb={2}
          isDisabled={true}
        >
          <SliderTrack>
            <SliderFilledTrack bg={accentColor} />
          </SliderTrack>
          <SliderThumb boxSize={4} bg={accentColor} />
        </Slider>
        <HStack justify="space-between">
          <Text fontSize="xs" color="gray.500">Small</Text>
          <Text fontSize="xs" color="gray.500">Large</Text>
        </HStack>
      </Box>

      <Box>
        <HStack justify="space-between" mb={2}>
          <Text fontSize="sm" fontWeight="medium">Widget Width</Text>
          <Badge colorScheme="green">{safeWidthMultiplier.toFixed(2)}×</Badge>
        </HStack>
        <Slider
          value={safeWidthMultiplier}
          min={0.5}
          max={2.5}
          step={0.05}
          onChange={handleWidgetWidthMultiplierChange}
          mb={2}
          isDisabled={true}
        >
          <SliderTrack>
            <SliderFilledTrack bg={accentColor} />
          </SliderTrack>
          <SliderThumb boxSize={4} bg={accentColor} />
        </Slider>
        <HStack justify="space-between">
          <Text fontSize="xs" color="gray.500">Narrow</Text>
          <Text fontSize="xs" color="gray.500">Wide</Text>
        </HStack>
      </Box>

      <Button 
        leftIcon={<FaArrowsAlt />} 
        onClick={resetWidgetSize}
        size="sm"
        colorScheme="gray"
        variant="outline"
        isDisabled={true}
      >
        Reset Size to Default
      </Button>
    </VStack>
  );
};

export default SizeTab;